import { render } from "./contact-and-social-buttons.vue?vue&type=template&id=de226694&scoped=true"
import script from "./contact-and-social-buttons.vue?vue&type=script&lang=js"
export * from "./contact-and-social-buttons.vue?vue&type=script&lang=js"

import "./contact-and-social-buttons.vue?vue&type=style&index=0&id=de226694&lang=scss&scoped=true"

import exportComponent from "/home/gebruiker/www/profs-computers/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de226694"]])

export default __exports__